<template>
  <el-dialog
    class="modal-export-stores"
    :title="title"
    :visible.sync="visible"
    @close="$_cancle"
    lock-scroll
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    append-to-body
    @submit.native.prevent
    custom-class="small"
  >
    <div class="content">
      <el-form
        ref="exportExceptions"
        :rules="rules"
        v-loading="isLoading"
        label-position="top"
        label-width="80px"
        :model="formData"
        class="export-exceptions__form"
      >
        <el-form-item label="请选择导出的数据范围及输入接收邮箱:" prop="mailbox">
          <el-input
            type="textarea"
            style="width: 373px; height: 152px;"
            resize="none"
            placeholder="请输入邮箱"
            v-model.trim="formData.mailbox"
          ></el-input>

          <span class="input-tips">*最多输入20个邮箱地址, 多个用", "隔开</span>
        </el-form-item>
      </el-form>
    </div>

    <div slot="footer" class="dialog-footer">
      <el-button class="submit__btn" @click="$_export">导出</el-button>
      <el-button @click="$_cancle">取消</el-button>
    </div>
  </el-dialog>
</template>

<script>
import * as Utils from "@/plugins/utils";

export default {
  name: "modal-export-stores",
  props: {
    title: { type: String, default: "" },
    filter: { type: Object, default: {}}
  },
  data() {
    return {
      visible: false,
      isLoading: false,
      formData: {
        mailbox: ""
      },
      rules: {
        mailbox: [
          { required: true, message: "请输入邮箱地址" },
          {
            validator: (rule, value, callback) => {
              if (value) {
                if (value.match(/\w.*,{2,}/) || value.match(/^[,].*/)) {
                  callback(new Error(`请输入正确的邮箱地址, 格式:"名称@域名"`));
                } else {
                  let mailbox = value.split(",").filter(email => email != "");
                  if (mailbox.length > 20) {
                    callback(new Error(`最多可输入20个邮箱地址!`));
                  }
                  const reg = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

                  let hasError = mailbox.some(item => {
                    return item.replace(/\s*/, "").match(reg) === null;
                  });

                  if (hasError) {
                    callback(
                      new Error(`请输入正确的邮箱地址, 格式:"名称@域名"`)
                    );
                  } else {
                    callback();
                  }
                }
              } else {
                callback();
              }
            },
            trigger: "blur"
          }
        ]
      }
    };
  },
  methods: {
    $_export() {
      this.$refs["exportExceptions"].validate(valid => {
        if (valid) {
          let {
            brandId,
						platformKey,
            mappingId,
						status,
            sysType,
            storeId,
            type,
          } = this.filter;

          const self = this;
          self.isLoading = true;
          self.$service
            .post("exportStoreMapping", {
              brandId,
              platformKey,
              mappingId,
              status,
              sysType,
              storeId,
              type,
              emails: this.formData.mailbox.split(',')
            })
            .then(result => {
              self.isLoading = false;
              if (result.$.checkResult(result, true)) {
                $MessageBox.alert({
                  content: result.msg,
                  onOk() {
                    self.$_cancle();
                  }
                });
              }
            });
        }
      });
    },

    $_cancle() {
      this.visible = false;
      this.$emit("close");
    }
  },
  mounted() {
    this.visible = true;
  }
};
</script>

<style lang="scss" scoped>
.content {
  padding: 20px 32px;
  position: relative;
  .title {
    height: 32px;
    color: #384e8c;
    font-size: 14px;
    font-weight: 700;
  }
  .export-exceptions__form {
    height: 366px;
  }
}
.select__btn {
  margin-left: 6px;
}
.input-tips{
  margin-left:10px;
}
</style>


